export class FilterSpec {
  attr: string
  value: string
  subFilters: Array<FilterSpec>

  public static createValueFilter(attributeName: string, value: any) {
    const filterSpec = FilterSpec.create(attributeName)
    filterSpec.value = value
    return filterSpec
  }

  public static createSubFilterFilter(attributeName: string, subFilters: Array<FilterSpec> = []) {
    const filterSpec = FilterSpec.create(attributeName)
    filterSpec.subFilters = subFilters
    return filterSpec
  }

  private static create(attributeName: string, value: any = undefined, subFilters: Array<FilterSpec> = []) {
    const filterSpec = new FilterSpec()
    filterSpec.attr = attributeName
    return filterSpec
  }

  public addFilter(filterSpec: FilterSpec) {
    if (!Array.isArray(this.subFilters)) {
      this.subFilters = []
    }
    this.subFilters.push(filterSpec)
  }

  public hasSubFilters() {
    return Array.isArray(this.subFilters) && this.subFilters.length > 0
  }

  public hasValueFilter() {
    return 'value' in this
  }

  public getAsValueFilter() {
    const result = new FilterSpec()
    result.attr = this.attr
    result.value = this.value
    return result
  }

  public getAsSubFilter() {
    const result = new FilterSpec()
    result.attr = this.attr
    result.subFilters = this.subFilters
    return result
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/filter-spec.ts